// @flow
import { titleToSlug } from '../../../services/titleToSlug'
import { numberToCurrency } from '../../../services/numberToCurrency'
import catalogMedia from './assets/catalog'

export default {
  productID: 'hardCoded.productID.daura',
  title: 'hardCoded.title.daura',
  slug: titleToSlug('hardCoded.title.daura'),
  catalog: {
    title: 'hardCoded.catalog.title.daura',
    catalogMedia,
    price: numberToCurrency('5.82'),
    color: '#d50e15'
  }
}
